// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PercentageOutlinedSvg from "@fishx/icons-svg/es/asn/PercentageOutlined";
import FishxIcon from '../components/FishxIcon';

var PercentageOutlined = function PercentageOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PercentageOutlinedSvg
  }));
};

PercentageOutlined.displayName = 'PercentageOutlined';
export default React.forwardRef(PercentageOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PercentageOutlined.js
// module id = 3772
// module chunks = 0